import React from 'react'

import {LayoutTypes} from './types'

export const LayoutContext = React.createContext<LayoutTypes>('default')
